var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpClothNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M930.1,772.8c-1.3-2.9-4.2-4.9-7.4-4.8h-85.4c-3.2,0-6.1,1.9-7.4,4.8l-185.1,432c-1.7,4.1,0.1,8.8,4.2,10.5 c1,0.4,2.1,0.6,3.1,0.6H736l184-136h-32l-110.7,39.5L880,880l144,336h83.9c4.4,0,8-3.6,8-8c0-1.1-0.2-2.2-0.6-3.1L930.1,772.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1160,832h48c4.4,0,8,3.6,8,8v368c0,4.4-3.6,8-8,8h-48c-4.4,0-8-3.6-8-8V840C1152,835.6,1155.6,832,1160,832z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1116.2,163.2L877.8,66.3c-3.8-1.5-7.9-2.3-12-2.3H755.5c-6.9,0-13,4.4-15.2,10.9L736,88 c-10.9,42.4-52.2,72-96,72s-85.1-29.6-96-72l-4.3-13.1c-2.2-6.5-8.3-10.9-15.2-10.9H414.2c-4.1,0-8.2,0.8-12,2.3l-238.4,96.9 c-6.9,2.8-11,10-9.8,17.4l35.8,222c1.3,7.8,8,13.4,15.8,13.4H384l30,120c1.3,5.2,1.3,10.7-0.1,15.9l-161.7,615.9 c-2.2,8.5,2.9,17.3,11.4,19.5c0.2,0.1,0.5,0.1,0.7,0.2l19.9,4.3c94,12.9,188.7,20.6,283.5,23.2c4.4,0.1,8.1-3.4,8.2-7.8 c0-0.1,0-0.1,0-0.2v-48c0-4.3-3.4-7.9-7.8-8c-80.2-2.3-160.4-8.3-239.6-18l144.1-557h334.5l31.6,122c0.9,3.5,4.1,6,7.8,6h49.1 c4.4,0,8-3.6,8-8c0-0.7-0.1-1.3-0.3-2l-37.3-142c-1.4-5.2-1.4-10.7-0.1-15.9l30-120h178.4c7.9,0,14.5-5.7,15.8-13.5l35.8-222 C1127.2,173.3,1123.1,166,1116.2,163.2z M1032,352H860.5c-7.3,0-13.7,5-15.5,12.1L807.5,512h-335l-37.5-147.9 c-1.8-7.1-8.2-12.1-15.5-12.1H248l-24-144l192-80h77.3c35.4,81,129.8,118,210.8,82.6c37-16.1,66.5-45.6,82.6-82.6H864l192,80 L1032,352z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpClothNormal);
export default __webpack_public_path__ + "static/media/hp_cloth_normal.39c20a89f305cfa085cc4ba597a1e766.svg";
export { ForwardRef as ReactComponent };